import axios, {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
} from "axios";
import toast from "react-hot-toast";
import authRedirectFlag from "../services/authRedirectFlag";

type Mode = 'api' | 'local';


//  Change the mode of application from getting data from API Endpoint or it should be local
export const mode: Mode = "api";

const axiosInstance: AxiosInstance = axios.create({
  // baseURL: "https://vttapi2.atwpl.com/api/v1",
  // baseURL: "http://localhost:3006/api/v1",
  // baseURL: "https://api.test.viliyo.com/api/v1",
  // baseURL: "https://api-backend-v3.viliyo.com/api/v1",
  baseURL: 'https://api-backend-management.viliyo.com/api/v1/',
  timeout: 100000, // Set the timeout value as per your requirements
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config: any) => {
    // Add any request headers or perform any modifications here
    const token = localStorage.getItem('token');
    if (config.method == "get") {
      config.data = { ...config.data };
      config.headers["Content-Type"] = "application/json";
    }

    if (config.method == "post") {
      config.data = { ...config.data, app: "Viliyo-Application" };
      config.headers["Content-Type"] = "application/json";
    }

    if (token && !config.url?.includes('/login')) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response: AxiosResponse<any>) => {
    // Handle successful responses
    return response.data;
  },
  (error: AxiosError<{ message: string }>) => {
    // Handle response errors
    if (error?.response?.status === 401) {
      if (!authRedirectFlag.active) {
        authRedirectFlag.active = true;
        window.localStorage.clear();
        window.location.replace('/login');
      }
      return Promise.reject('Unauthorized Access');
    }

    toast.error(error.message || 'Something went wrong');

    return Promise.reject(error);
  }
);

export default axiosInstance;
